import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {environment} from '@environment/environment';
import {GlobalProvider} from '@core/model/global-provider';
import {Provider} from "@core/model/providers";
import _ from "lodash";

@Injectable()
export class ProviderService {

  constructor(private http: HttpClient) {
    // Initialization logic can go here if needed
  }

  public processProvidersWithGlobalProviders(localProviders: Provider[], globalProviders: Provider[]): Provider[] {
    return localProviders.map(p => {
      if (!p.base64Icon) {
        const global = globalProviders.find(
          g => g.name.toLowerCase().trim() === p.name.toLowerCase().trim()
        );
        if (global && global.base64Icon) {
          return {
            ...p,
            base64Icon: `data:image/${global.extension};base64,${global.base64Icon}`,
          };
        }
      }
      return p;
    });
  }


  //api calls
  public getProviders(mapId: string) {
    return this.http.get(`${environment.apiDatacentersUrl}/providers/local/${mapId}`, {responseType: 'json'}).pipe(

    );
  }

  public getGlobalProviders(params: any): Observable<PaginatedResultModel<GlobalProvider>> {
    return this.http.get<PaginatedResultModel<GlobalProvider>>(`${environment.apiDatacentersUrl}/providers/global`, {
      responseType: 'json',
      params
    });
  }

  public deleteGlobalProvider(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiDatacentersUrl}/providers/global/${id}`, {responseType: 'json'});
  }

  public getGlobalProvider(globalProviderId: string): Observable<PaginatedResultModel<GlobalProvider>> {
    return this.http.get<PaginatedResultModel<GlobalProvider>>(`${environment.apiDatacentersUrl}/providers/global/${globalProviderId}`, {responseType: 'json'});
  }

  public saveGlobalProvider(provider: Provider): Observable<Provider> {
    const providerToSave = {
      id: provider.id,
      providerName: provider.name,
      logo: provider.base64Icon?.toString().replace(/^data:image\/[a-z]+;base64,/, '') || '',
      extension: provider.extension,
      description: provider.description,
    }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (!providerToSave.id) {
      return this.http.post<Provider>(`${environment.apiDatacentersUrl}/providers/global`, providerToSave, httpOptions);
    } else {
      return this.http.put<Provider>(`${environment.apiDatacentersUrl}/providers/global`, providerToSave, httpOptions);
    }

  }
}
